import { render, staticRenderFns } from "./EmbedSession.vue?vue&type=template&id=2221ee80"
import script from "./EmbedSession.vue?vue&type=script&lang=js"
export * from "./EmbedSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports